import React from 'react';
import { useStore } from '../../../../store';
import { validateFeatureFlag } from '../../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../../constants/general';
import { ProfilePlanPromotion } from '../../../profile/components/ProfilePlanPromotion';
import { LiliPlanType } from '../../../planUpgrade/constants';

export const UpgradePlan = () => {
  const profileType = useStore(state => state.summary.customer.customerProfile);

  return (
    <div>
      {profileType !== LiliPlanType.PREMIUM && validateFeatureFlag(FEATURE_FLAG.PLAN_UPGRADE) && <ProfilePlanPromotion planType={profileType} />}
    </div>
  );
};
